import { render } from "./vipClass.vue?vue&type=template&id=830378a8&scoped=true&ts=true"
import script from "./vipClass.vue?vue&type=script&lang=ts"
export * from "./vipClass.vue?vue&type=script&lang=ts"

import "./vipClass.vue?vue&type=style&index=0&id=830378a8&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830378a8"]])

export default __exports__